import { createGet, createGetByText, createPost } from './base.js';

export const GetReport = createGet('report');
export const GetByTextReport = createGetByText('report');
export const PostReport = createPost('report');
